import React, { useEffect, useState } from 'react'

export const Navigation = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };
  return (
    <header>
      <div id="menu" className="navbar-default navbar-fixed-top">
        <div className="container">
          <div className="header-row">

            <div className="navbar-header">
              <a href="/">
                <img
                  className="logo"
                  src="img/logo.jpeg"
                  alt="logo"
                />
              </a>
            </div>

            <div className="contact-details">
              <div className="phonea">
                <i className="fa fa-phone"></i>
                <a href="tel:9873595929">9873595929</a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </header>
  )
}
